
















import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, Mutation } from 'vuex-class'

import _get from 'lodash/get'
import _toLower from 'lodash/toLower'

import { Book, Seller, Offer } from '@/types'

@Component({
  components: {},
})
export default class ActiveOfferBar extends Vue {
  @Getter('getUserInfo', { namespace: 'auth' }) private userInfo: any
  @Getter('getActiveOffer', { namespace: 'offerCarts' }) private activeOffer: Offer | undefined
  @Getter('getActiveSeller', { namespace: 'sellers' }) private activeSeller: Seller | undefined

  @Mutation('setActiveOffer', { namespace: 'offerCarts' }) private setActiveOffer: any
  @Mutation('setActiveSeller', { namespace: 'sellers' }) private setActiveSeller: any

  get recipientName() {
    const userRole = _toLower(_get(this.userInfo, ['role', 'name']))
    if (userRole === 'seller') {
      return _get(this.userInfo, ['sellerUsers', 0, 'seller', 'buyerUser', 'name']) || ''
    } else {
      return _get(this.activeSeller, ['name']) || ''
    }
  }

  private handleClickActiveOffer() {
    if (this.$route.name === 'OfferCart') return
    this.$router.push({ name: 'OfferCart' })
  }

  private handleClostOffer() {
    this.setActiveSeller({ seller: null })
    this.setActiveOffer({ offer: null })
  }
}
